import { Link } from "react-router-dom";
import type { Movie } from "@/types/cinema";

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/movie/${movie.id}`}
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 电影海报`}
          title={`${movie.title} 九七电影院`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-full bg-primary-950/80 px-2 py-0.5 text-xs font-medium text-accent-400">
          <i className="ri-star-fill text-[10px]"></i>
          {movie.rating.toFixed(1)}
        </span>
        {movie.status === "upcoming" && (
          <span className="absolute right-2 top-2 rounded-full bg-accent-500 px-2 py-0.5 text-xs font-medium text-background-50">
            即将上映
          </span>
        )}
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-primary-950/90 to-transparent p-3 pt-8">
          <p className="truncate text-xs text-background-100">
            {movie.genres.join(" · ")}
          </p>
        </div>
      </div>
      <div className="p-3">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-600">
          {movie.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {movie.releaseDate} 上映
        </p>
      </div>
    </Link>
  );
}